import React from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import SummaryPanel from '@/components/Cluster/SummaryPanel';
import { getCurrentCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';

function Summary({ overview, currentCluster }) {
  const isContainer = currentCluster?.deployEnv === 'container';

  const items = [
    {
      title: 'Topic',
      icon: 'topic',
      info: <CountUp end={overview.topicPartitionCount} duration={0.4} />,
    },
    {
      title: 'Bundles',
      icon: 'other2',
      info: <CountUp end={overview.bundleCount} duration={0.4} />,
      tip: '分配的Bundle个数（可进行负载均衡最小粒度）。',
    },
    isContainer
      ? {
          title: '连接数',
          icon: 'other3',
          info: <CountUp end={overview.connectCount} duration={0.4} />,
        }
      : {
          title: '负载',
          icon: 'other3',
          info: <CountUp end={overview.overLoad} duration={0.4} decimals={2} />,
          unit: '%',
        },
  ];
  return <SummaryPanel shadow={false} img={null} items={items} />;
}

export default connect((state) => ({
  currentCluster: getCurrentCluster(state.cluster.allList),
}))(Summary);
